/*
 * @Author: Teemo Ding
 * @Date: 2021-07-21 14:15:41
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-13 11:03:18
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelPayment/CurrencyConversion/index.tsx
 */
import { Checkbox } from '@/src/components/Antd';
import Configuration from '@/src/components/Configuration/Configuration';
import Table from '@/src/components/EditableTable/EditableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Button } from 'antd';
import React from 'react';
import { currencyColumns } from '../config';
import css from '../css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const CurrencyConversion = ({
  enableThirdPartyCurrency,
  currencyConversion,
  handleSelectCurrency,
  setEnableThirdPartyCurrency,
  deleteFun,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      // containerClassName={css.invoiceFormat}
      title={getI18n(
        'salesChannelPayment.index.thirdPartyDynamicCurrencyConversion',
      )}>
      <Checkbox
        checked={enableThirdPartyCurrency}
        onChange={(value) => {
          setEnableThirdPartyCurrency(value);
        }}
        className={css.thirdPartyCheckbox}
        disabled={disableEdit}>
        <span>
          {getI18n(
            'salesChannelPayment.index.enableThirdPartyDynamicCurrencyConversion',
          )}
        </span>
      </Checkbox>

      {enableThirdPartyCurrency && !currencyConversion.length && (
        <p>
          {getI18n(
            'salesChannelPayment.index.noselectedadditionalchargecurrency',
          )}
        </p>
      )}
      {enableThirdPartyCurrency && !!currencyConversion.length && (
        <Table
          id='currencyConversion'
          rowKey='uuid'
          className={css.globalStoreTable}
          columns={currencyColumns(deleteFun, disableEdit, { getI18n })}
          dataSource={currencyConversion}
        />
      )}

      {enableThirdPartyCurrency && (
        <Button
          type='primary'
          onClick={() => handleSelectCurrency()}
          className={css.selectedBtn}
          disabled={disableEdit}>
          {getI18n('salesChannelPayment.index.selectAdditionalChargeCurrency')}
        </Button>
      )}
      <Configuration
        configStart={getI18n('salesChannelPayment.index.gotoStoreSettings')}
        linkTo={`/settings/currency`}
        configLink={getI18n('salesChannelPayment.index.currency')}
        configEnd={getI18n(
          'salesChannelPayment.index.tosetuptheavailablecurrencies',
        )}
      />
    </SectionWrapper>
  );
};

export default CurrencyConversion;
